<app-page-title [title]="!id ? 'Cadastrar membro' : 'Alterar membro'"></app-page-title>
<div class="form-container">
  <div *ngIf="id" class="profile-image-container" (click)="changeAvatar()">
    <img *ngIf="currentAvatar" [src]="currentAvatar" id="profile-image" />
    <img *ngIf="!currentAvatar" src="../../../assets/icons/default-user-icon-profile.png" id="profile-image" />
    <img src="../../../assets/icons/edit.svg" class="edit-icon" />
  </div>
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline" id="name">
      <mat-label>Nome</mat-label>
      <input matInput placeholder="Nome" formControlName="name" name="name" />
      <mat-error *ngIf="form.controls.name.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <div>
      <label id="example-radio-group-label">Sexo:</label>
      <br />
      <mat-radio-group aria-label="Select an option" formControlName="gender" color="primary" class="gender">
        <mat-radio-button value="M">Masculino</mat-radio-button>
        <mat-radio-button value="F">Feminino</mat-radio-button>

        <mat-error *ngIf="form.controls.gender.hasError('required')"> Obrigatorio </mat-error>
      </mat-radio-group>
    </div>
    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>CPF</mat-label>
      <input
        formControlName="cpf"
        autocomplete="off"
        type="text"
        matInput
        appCpf
        placeholder="000.000.000-00"
        appCpfMaskTwo
        maxlength="14"
      />
      <mat-error *ngIf="form.controls.cpf.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput placeholder="email" formControlName="email" />

      <mat-error *ngIf="form.controls.email.hasError('email')"> Email invalido </mat-error>
      <mat-error *ngIf="form.controls.email.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Celular</mat-label>
      <input matInput placeholder="(82) 98121-3141" formControlName="phone_number" appPhoneMask maxlength="14" />
      <mat-error *ngIf="form.controls.phone_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Data de nascimento</mat-label>
      <input matInput placeholder="email" formControlName="bhirth_date" type="date" />
      <mat-error *ngIf="form.controls.bhirth_date.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>CEP</mat-label>
      <input
        formControlName="cep"
        autocomplete="off"
        type="text"
        matInput
        appCepMask
        placeholder="00000-000"
        maxlength="9"
      />
      <mat-error *ngIf="form.controls.cep.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>
    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Estado</mat-label>
      <mat-select (selectionChange)="changeCity($event.value)" formControlName="state_id">
        <mat-option *ngFor="let state of states" [value]="state.ID">
          {{ state.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Cidade</mat-label>
      <mat-select formControlName="city_id">
        <mat-option *ngFor="let city of cities" [value]="city.ID">
          {{ city.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>endereço</mat-label>
      <input matInput placeholder="endereço" formControlName="street" />
      <mat-error *ngIf="form.controls.street.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Complemento</mat-label>
      <input matInput placeholder="Complemento" formControlName="complement" />
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline" id="home_number">
      <mat-label>Nº</mat-label>
      <input matInput placeholder="nº" formControlName="home_number" />
      <mat-error *ngIf="form.controls.home_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Célula</mat-label>
      <mat-select formControlName="group_id">
        <mat-option *ngFor="let group of groups" [value]="group.id">
          {{ group.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Função</mat-label>
      <mat-select formControlName="group_function_id">
        <mat-option *ngFor="let function of functions" [value]="function.id">
          {{ function.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline" id="home_number" *ngIf="!discipler?.name">
      <mat-label>Discipulador(CECID)</mat-label>
      <input matInput placeholder="Discipulador" formControlName="discipler_id" #cecid />
      <button mat-icon-button matSuffix (click)="findByCECID(cecid.value)">
        <mat-icon>search</mat-icon>
      </button>
      <mat-error> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline" id="name" *ngIf="discipler?.name">
      <mat-label>Discipulador</mat-label>
      <input matInput placeholder="Nome" [value]="discipler?.name" disabled />
      <button mat-icon-button matSuffix (click)="clearDiscipler()" *ngIf="discipler?.name">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Status na Igreja</mat-label>
      <mat-select formControlName="church_status">
        <mat-option *ngFor="let status of churchStatuses" [value]="status.value">
          {{ status.title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Sangue</mat-label>
      <mat-select formControlName="blood_type">
        <mat-option *ngFor="let blood of bloods" [value]="blood">
          {{ blood }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <br />

    <div class="buttons-container">
      <button *ngIf="!id" (click)="register()" mat-raised-button class="btn-primary">Cadastrar</button>

      <button *ngIf="id" (click)="update()" class="btn-primary" mat-raised-button>Salvar</button>
    </div>
  </form>
</div>
